import React from "react"

import { GgrSettings } from "services/settings/type"

import { formatDateTime, formatFiatCurrency } from "util/formatter"

type GgrScopeDetailProps = {
  label: string
  snapshot: NonNullable<GgrSettings["cache"]>
  limit: number
  percent: number
  isLimitReached: boolean
}

export const GgrScopeDetail: React.FC<GgrScopeDetailProps> = ({ label, snapshot, limit, percent, isLimitReached }) => {
  const rows = [
    { label: "Current GGR", value: formatFiatCurrency(snapshot.current, "$0.00") },
    { label: "GGR limit", value: formatFiatCurrency(limit, "$0.00") },
    { label: "Used", value: `${percent}%` }
  ]

  return (
    <div>
      <div className="font-semibold mb-1">{label}</div>
      {rows.map((row) => (
        <div key={row.label} className="flex justify-between mb-1">
          <span className="text-gray-500 dark:text-gray-400">{row.label}</span>
          <span className="font-semibold">{row.value}</span>
        </div>
      ))}
      <div className="text-[11px] text-gray-500 dark:text-gray-400">
        as of <span className="font-mono">{formatDateTime(snapshot.lastCheckedAt)}</span>
      </div>
      {isLimitReached && (
        <div className="mt-1 text-[11px] font-semibold text-red-500">Limit reached – new games are currently blocked.</div>
      )}
    </div>
  )
}
